import { graphFamilyRegistry } from '../Graph/GraphRegistry';

export const useGraphBuildResult = (familyKey, context) => {
  const builderResults = graphFamilyRegistry.map((entry) => ({
    familyKey: entry.familyKey,
    result: entry.useGraphBuilder(context),
  }));

  return (
    builderResults.find((entry) => entry.familyKey === familyKey)?.result ??
    builderResults[0]?.result ?? { option: null, emptyMessage: 'No device selected' }
  );
};
